import { DragLayerComponent } from './DragLayer.component';
import { enhance } from './DragLayer.enhancers';

export const DragLayer = enhance(DragLayerComponent);
